import { useTranslation } from 'react-i18next';
import { Header } from '@anytag/shared-molecules';
import { Button } from '@anytag/shared-atoms';
import { useDownloadYoutubeCMSCsv } from './hooks';

export const YoutubeCMSHeader = () => {
  const { t } = useTranslation();
  const { openDownloadModal, DownloadCsvModal } = useDownloadYoutubeCMSCsv();

  return (
    <div>
      <Header>
        <Button
          variant="solid"
          onClick={openDownloadModal}
          css={{ marginLeft: 'auto' }}
          title={t('Button.Download Revenue')}
        />
      </Header>

      {DownloadCsvModal}
    </div>
  );
};
